import {
  useEffect,
  useState,
} from 'react';

import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { TinhluongAction } from 'src/actions/tinhluong.action';
import {
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';

import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  TextField,
} from '@material-ui/core';

import numeral from 'numeral';

const TinhluongDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const { items, total, filter, tongDoanhThuTamTinh, tongDoanhThuThucTe } = useSelector(state => state.tinhluong);
  const { role } = useSelector(state => state.profile);

  const [limit, setLimit] = useState(filter && typeof filter.limit !== 'undefined' ? filter.limit : DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(filter && typeof filter.page !== 'undefined' ? filter.page : 0);
  const [updateUserValue, setUpdateUserValue] = useState({});


  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    
    dispatch(TinhluongAction.updateFilter(payload));

    dispatch(TinhluongAction.list());
  }, [page, limit])

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // const handleUserChange = (event, username, track0, track1) => {
  //   if (event.key === 'Enter') {
  //     username = username.trim();
  //     if (username != '') {
  //       setUpdateUserValue({
  //         ...updateUserValue,
  //         [track0 + '_' + track1]: username,
  //       });
  //       dispatch(TinhluongAction.updateUser(username, track0, track1));
  //     }
  //   }
  // };

  const handleUserChange = (event, username, track0, track1) => {
    username = username.trim();
    if (username != '') {
      setUpdateUserValue({
        ...updateUserValue,
        [track0 + '_' + track1]: username,
      });
      dispatch(TinhluongAction.updateUser(username, track0, track1));
    }
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{color: "green"}}>
                  TỔNG DOANH THU THỰC TẾ
                </TableCell>
                {1 < 0 && <TableCell>

                </TableCell>}
                <TableCell style={{color: "green"}}>
                  TỔNG DOANH THU TẠM TÍNH
                </TableCell>
                <TableCell style={{color: "green"}}>
                  TỔNG HOÀN TIỀN
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{color: "green"}}>
                  {numeral(tongDoanhThuThucTe).format('0,0')}
                </TableCell>
                {1 < 0 && <TableCell style={{color: "green"}}>
                  
                </TableCell>}
                <TableCell style={{color: "green"}}>
                  {numeral(tongDoanhThuTamTinh).format('0,0')}
                </TableCell>
                <TableCell style={{color: "green"}}>
                  {numeral(tongDoanhThuTamTinh - tongDoanhThuThucTe).format('0,0')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Username NV
                </TableCell>
                <TableCell>
                  Tên NV
                </TableCell>
                <TableCell>
                  Tổng gói
                </TableCell>
                <TableCell>
                  Doanh thu thực tế
                </TableCell>
                {1 < 0 && <TableCell>
                  Doanh thu báo đỏ
                </TableCell>}
                <TableCell>
                  Doanh thu tạm tính
                </TableCell>
                <TableCell>
                  Tổng hoàn tiền
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.slice(page * limit, (page + 1) * limit).map((tinhluong, index) => (
                <TableRow
                  hover
                  key={tinhluong.track0 + '_' + tinhluong.track1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    {tinhluong.username_nv}
                  </TableCell>
                  <TableCell>
                    {tinhluong.ten_nv}
                  </TableCell>
                  <TableCell>
                    {numeral(tinhluong.don_moi).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(tinhluong.doanh_thu_thuc_te).format('0,0')}
                  </TableCell>
                  {1 < 0 && <TableCell>
                    {numeral(tinhluong.doanh_thu_bao_do).format('0,0')}
                  </TableCell>}
                  <TableCell>
                    {numeral(tinhluong.doanh_thu_tam_tinh).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(tinhluong.doanh_thu_tam_tinh - tinhluong.doanh_thu_thuc_te).format('0,0')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
    </Card>
  );
};

export default TinhluongDetail;
